module.exports = __webpack_public_path__ + "img/settled-title.221dfbd1.png";